import React, { useEffect } from "react";
import { Card, Divider } from "antd";
import { connect } from "react-redux";
import { USABLE_ICONS } from "variables/constants";
import { getEmployeeAwardList } from "../../../../../redux/employeeaward/employeeAwardState";
import dayjs from "dayjs";

const MyNominationCard = ({ recordList, pagination, doSearch }) => {
  
  useEffect(() => {
    doSearch({paginate: pagination.per_page});
  }, [doSearch, pagination.per_page]);

  const formatStatus = (statusId) => {
    return statusId === 1 ? "Approved" : "Pending";
  };

  return (
    <>
      {recordList?.map((item) => {
        const colorClass = item?.award_color_class?.toLowerCase();

        const IconComponent =
          item?.award_icon && USABLE_ICONS[item.award_icon]
            ? USABLE_ICONS[item.award_icon]
            : null;

        const statusText = formatStatus(item?.ema_status_id);

        return (
          <Card
            key={item?.ema_id}
            className={`rounded-2xl overflow-y-auto pr-2 mb-2 nomination dark-mode-card ${colorClass || ""}`}
          >
            <div className="flex justify-between items-start relative">
              <span
                className={`absolute right-5 text-xs text-white p-2 icon-style ${colorClass || ""}`}
              >
                {IconComponent &&
                  React.createElement(IconComponent, {
                    className: "h-5 w-5"
                  })}
                  
              </span>

              <div className="flex items-center space-x-3">

                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-green-100 text-green-700 font-semibold">
                  {item?.employee_name
                    ?.split(" ")
                    .map(n => n[0])
                    .join("")}
                </div>

                <div>
                  <div className="flex gap-2 flex-wrap">

                    <h4 className="font-semibold text-base title-text">
                      {item?.employee_name}
                    </h4>

                    <span className="status-indicator normal text-[10px] muted-text">
                      EMP Code: {item?.employee_code}
                    </span>

                    <span className={`status-indicator ${statusText.toLowerCase()} text-[10px] px-2`}>
                      {statusText}
                    </span>

                  </div>

                  <p className="text-gray-600 text-[13px]">
                    Nominated by: {item?.nominator_name || "System"}
                  </p>
                </div>
              </div>
            </div>

            <Divider style={{ margin: "0.5rem 0", borderColor: "#e5e7eb" }} />

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">

              <div>
                <p className="text-base mb-1 muted-text">
                  Award Category
                </p>
                <div className="text-base font-medium title-text">
                  {item?.award_title}
                </div>
              </div>

              <div>
                <p className="text-base text-gray-500 mb-1">
                  Nomination Date
                </p>
                <div className="text-base font-medium title-text">
                  {item?.ema_issued_at
                    ? new dayjs(item.ema_issued_at).format("MMMM D, YYYY")
                    : "-"}
                </div>
              </div>

            </div>
          </Card>
        );
      })}
    </>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.employeeAward.employeeAwardList?.items,
  pagination: state.employeeAward.employeeAwardList?.pagination,
  filters: state.employeeAward.employeeAwardList?.filters,
  requesting: state.employeeAward.employeeAwardList?.requesting,
  error: state.employeeAward.employeeAwardList?.error,

});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getEmployeeAwardList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MyNominationCard);